import React from "react";


import Sidenavpatient from "./Sidenavpatient";
import Ddetails1 from "./ddetails1";
import Ddetails2 from "./ddetails2";


function Patientdoctordetails() {
    return (
        <>
            <Sidenavpatient />
            <Ddetails1 />
            <Ddetails2 />
        </>
    )
}

export default Patientdoctordetails;
